import { file, get, post } from "../../api"; // API Types
import * as types from "./types.js"; // Redux actions payload types
import Routes from "./../../api/routes"; // API endpoint routes
import { set_user_info_storage } from "../../utils";
const {
  USER_DETAILS,
  DOCUMENT_UPLOAD,
  DELETE_LICENSE,
  DELETE_INSURANCE,
  USER_PHONE_EXIST,
  GUEST_PROFILE,
  LICENCE_VERIFICATION,
  LICENCE_ADDRESS_APPLY,
  LICENCE_ADDRESS_DISMISS,
} = Routes;
import {
  setShowDocumentHideProfile,
  setShowEditProfileHideShowProfile,
  setShowPaymentHideShowProfile,
  showSuccessPopup,
} from "./ui";

/******************** 
@purpose : Used for get user information
@Parameter : { data, dispatch }
@Author : INIC
******************/
export const getUserInfo =
  (loader = true) =>
  (dispatch) => {
    return get(USER_DETAILS, false, loader).then((res) => {
      if (res?.statusCode == 200) {
        dispatch(setUserInfo(res.data));
        return Promise.resolve(res.data);
      }
      return Promise.reject(res);
    });
  };

export const updateUserInfo = (data) => (dispatch) => {
  return file(USER_DETAILS, true, data)
    .then((res) => {
      if (res?.statusCode == 200) {
        dispatch(setUserInfo(res.data));
        return Promise.resolve(res);
      }
      // Display error message in toast if API call fails
      const errorMessage =
        res?.custom_errors ||
        res?.error ||
        "Failed to update profile. Please try again.";
      dispatch(showSuccessPopup(errorMessage, true));
      return Promise.reject(res);
    })
    .catch((error) => {
      // Handle network or other unexpected errors
      const errorMessage =
        error?.custom_errors ||
        error?.error ||
        "An error occurred while updating profile. Please try again.";
      dispatch(showSuccessPopup(errorMessage, true));
      return Promise.reject(error);
    });
};

/******************** 
@purpose : Used for store logout responce and remove token in cookie
@Parameter : { }
@Author : INIC
******************/
export const setUserInfo = (data) => {
  set_user_info_storage(data);
  return {
    type: types.SET_USER_INFO,
    data,
  };
};

export const uploadDocuments = (data) => (dispatch) => {
  return file(DOCUMENT_UPLOAD, true, data).then((res) => {
    if (res?.statusCode == 200) {
      dispatch(setUserInfo(res.data));
      dispatch(showSuccessPopup(res.message));
      return res.data;
    }
    return Promise.reject(res);
  });
};

export const deleteLicense = () => (dispatch) => {
  return post(DELETE_LICENSE, true, {}).then((res) => {
    if (res?.success) {
      dispatch(getUserInfo());
      dispatch(setShowEditProfileHideShowProfile(true));
      dispatch(setShowDocumentHideProfile(true));
      dispatch(setShowPaymentHideShowProfile(true));
      // Router.push('/personal-details')
      return Promise.resolve(res.data);
    }
    return Promise.reject(res);
  });
};

export const deleteInsurance = () => (dispatch) => {
  return post(DELETE_INSURANCE, true, {}).then((res) => {
    if (res?.success) {
      dispatch(getUserInfo());
      dispatch(setShowEditProfileHideShowProfile(true));
      dispatch(setShowDocumentHideProfile(true));
      dispatch(setShowPaymentHideShowProfile(true));
      // Router.push('/personal-details')
      return Promise.resolve(res.data);
    }
    return Promise.reject(res);
  });
};

/********************
@purpose : Keep the Stripe licence verification status inside userInfo
@Parameter : { data }
******************/
export const setLicenceVerification = (data) => (dispatch, getState) => {
  const userInfo = getState()?.user?.userInfo;
  if (!userInfo || !data) return;
  dispatch(setUserInfo({ ...userInfo, licence_verification: data }));
};

/********************
@purpose : Read the licence verification status (silent, used for polling)
@Parameter : {}
******************/
export const getLicenceVerification = () => (dispatch) => {
  return get(LICENCE_VERIFICATION, false, false).then((res) => {
    if (res?.statusCode == 200) {
      dispatch(setLicenceVerification(res.data));
      return Promise.resolve(res.data);
    }
    return Promise.reject(res);
  });
};

/********************
@purpose : Start or continue a Stripe Identity licence verification
@Parameter : {}
******************/
export const startLicenceVerification = () => (dispatch) => {
  return post(LICENCE_VERIFICATION, false, {}, false).then((res) => {
    if (res?.statusCode == 200 && res?.data?.session?.client_secret) {
      dispatch(setLicenceVerification(res.data));
      return Promise.resolve(res.data);
    }
    // The open session was already verified: no new Stripe session is needed.
    if (res?.statusCode == 200) {
      dispatch(getUserInfo(false));
      dispatch(showSuccessPopup(res.message));
      return Promise.resolve(res.data);
    }
    dispatch(
      showSuccessPopup(
        res?.message || "We couldn't start the verification. Please try again.",
        true
      )
    );
    return Promise.reject(res);
  });
};

/********************
@purpose : Use or dismiss the address read from the verified licence
@Parameter : { apply }
******************/
export const resolveLicenceAddress = (apply) => (dispatch) => {
  const url = apply ? LICENCE_ADDRESS_APPLY : LICENCE_ADDRESS_DISMISS;
  return post(url, false, {}, false).then((res) => {
    if (res?.statusCode == 200) {
      dispatch(getUserInfo(false));
      if (apply) dispatch(showSuccessPopup(res.message));
      return Promise.resolve(res.data);
    }
    dispatch(showSuccessPopup(res?.message || "Something went wrong.", true));
    return Promise.reject(res);
  });
};

/******************** 
@purpose : Used for get user information
@Parameter : { data, dispatch }
@Author : INIC
******************/
export const userPhoneExist = (data) => () => {
  return post(USER_PHONE_EXIST, false, data).then((res) => {
    if (res) {
      return res;
    }
    return Promise.reject(res);
  });
};

export const updateGuestUserInfo = (data) => (dispatch) => {
  return file(GUEST_PROFILE, true, data)
    .then((res) => {
      if (res?.statusCode == 200) {
        dispatch(setUserInfo(res.data));
        return Promise.resolve(res);
      }
      // Display error message in toast if API call fails
      const errorMessage =
        res?.custom_errors ||
        res?.error ||
        "Failed to update profile. Please try again.";
      dispatch(showSuccessPopup(errorMessage, true));
      return Promise.reject(res);
    })
    .catch((error) => {
      // Handle network or other unexpected errors
      const errorMessage =
        error?.custom_errors ||
        error?.error ||
        "An error occurred while updating profile. Please try again.";
      dispatch(showSuccessPopup(errorMessage, true));
      return Promise.reject(error);
    });
};
